import { styled } from '../../theme/styled';

export const BoldSpan = styled.span`
  font-weight: ${(props) => props.theme.font.weights.semiBold};
`;

export const LightSpan = styled.span`
  color: ${(props) => props.theme.configuration.secondaryTextColor};
`;

export const PartlyHighlightedText: React.FC<{
  text: string;
  textToHighlight: string;
  providerPrefix?: string;
}> = ({ text, textToHighlight, providerPrefix }) => {
  if (!textToHighlight && providerPrefix) {
    const textWithoutPrefix = text.replace(providerPrefix, '');

    return (
      <span translate="no">
        <LightSpan data-testid="de-emphasized-prefix">{providerPrefix}</LightSpan>
        {textWithoutPrefix}
      </span>
    );
  }

  if (!textToHighlight) {
    return <span translate="no">{text}</span>;
  }

  const textToHighlightParts = textToHighlight
    .toLowerCase()
    // We first split the text to highlight by spaces
    .split(' ')
    // We remove special characters of the query
    // Those characters would have to be escaped for the regex afterwards
    .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, ''))
    // To be sure, we filter out empty strings
    .filter((term) => term.length > 0);

  // Build a regex from the parts of the text to highlight.
  const regexp = new RegExp(`(${textToHighlightParts.join('|')})`, 'gi');
  // Finally split the full text by the prepared regex (by the parts of the text to highlight).
  const pieces = text.split(regexp);

  return (
    <span translate="no">
      {pieces.map((piece: string, i) => {
        const key = `${piece}-${i}`;

        return textToHighlightParts.includes(piece.toLowerCase()) ? (
          <BoldSpan data-testid="highlighted-text" key={key}>
            {piece}
          </BoldSpan>
        ) : (
          <span key={key}>{piece}</span>
        );
      })}
    </span>
  );
};
